import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core'
import {ControlType} from '../dynamic-form'
import {sortByLowestRank} from '../../../../core/utils/sort-by-lowest-rank'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {faCheck} from '@fortawesome/pro-solid-svg-icons/faCheck'

@Component({
  selector: 'bgo-dynamic-form-summary',
  templateUrl: './dynamic-form-summary.component.html',
  styleUrls: ['./dynamic-form-summary.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicFormSummaryComponent {
  questions = input.required<DynamicQuestionSummary[]>()
  size = input<'sm' | 'default'>('default')

  readonly itemProps = computed<{border: boolean; icon?: IconDefinition; size: 'sm' | 'default'}>(() => {
    const size = this.size()
    if (size === 'sm') {
      return {
        border: false,
        icon: faCheck,
        size: 'sm',
      }
    } else {
      return {
        border: true,
        size: 'default',
      }
    }
  })

  get questionsSorted(): DynamicQuestionSummary[] {
    return this.questions().sort(sortByLowestRank)
  }
}

export interface DynamicQuestionSummary {
  rank: number
  label: string
  type: ControlType
  answers: string[]
  additionalInformation?: string
}
